import { Component, Mixins } from 'vue-property-decorator';
import ProjectMixin from './ProjectMixins';

@Component({})
export default class ProjectMobile extends Mixins(ProjectMixin) {
  async mobileTapListener() {
    // listen to both single and double click
    this.tapCount++;

    if (this.tapCount === 1) {
      setTimeout(() => {
        if (this.tapCount === 1) {
          this.onProjectClick();
        } else {
          this.setProjectAsActive();
        }
        this.tapCount = 0;
      }, 300);

      return;
    }
  }
}
